import { CollectionResponse } from 'api/product';
import { useContentful } from 'modules/content-cms/components/context';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import React from 'react';
import canonical from '../../../components/seo/canonical';
import description from '../../../components/seo/description';
import seoImage from '../../../components/seo/image';
import robots from '../../../components/seo/robots';
import title from '../../../components/seo/title';
import seotype from '../../../components/seo/type';
import LandingPageForNewCustomer from '../components/landing-page-new-customer-cat';

const LandingPageForEcCustomerAsync = dynamic(
  () => import('../components/landing-page-ec-customer-cat'),
  { ssr: false }
);

interface CollectionType {
  title: string;
  collectionHandle: string;
}

interface PropTypes {
  ecCollection: CollectionResponse;
  allCollections: CollectionType[];
  isExistingCustomer: boolean;
}

const Cats: React.FC<PropTypes> = ({
  ecCollection,
  allCollections,
  isExistingCustomer,
}) => {
  const { data: contentfulData } = useContentful();

  const headComponent = (
    <Head>
      {title(contentfulData.fields.headline)}
      {description(contentfulData.fields.metaDescription)}
      {seotype()}
      {robots(contentfulData.fields.metaRobots)}
      {canonical(contentfulData.fields.handle)}
      {seoImage(
        contentfulData.fields.metaOgImage &&
          contentfulData.fields.metaOgImage.fields.file.url
      )}
    </Head>
  );

  return (
    <>
      {headComponent}
      {isExistingCustomer ? (
        <LandingPageForEcCustomerAsync
          ecCollection={ecCollection}
          allCollections={allCollections}
        />
      ) : (
        <LandingPageForNewCustomer />
      )}
    </>
  );
};

export default Cats;
